import {Component, OnInit, ViewChild} from '@angular/core';
import {RoamingPartnersModel} from "../../models/roaming-partners.model";
import {NgForm} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {UserVerificationService} from "../../services/user-verification.service";
import {Location} from "@angular/common";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ApiEndpoints} from "../../services/api-endpoints";

@Component({ standalone: false, 
  selector: 'app-edit-roaming-partners',
  templateUrl: './edit-roaming-partners.component.html',
})
export class EditRoamingPartnersComponent implements OnInit {

  public roamingPartnersModel: RoamingPartnersModel;
  public title;
  public nsBid;
  public nsAid;
  public name;
  public partnerName;
  public netIds;
  public partnerNetIds;
  public roamingPolicyType;
  public searchText = '';
  public allNetworks: any;
  public showSearch = false;

  @ViewChild('validate', { static: true }) validate: NgForm;

  constructor(private router: Router,
              private route: ActivatedRoute,
              userVerificationService: UserVerificationService,
              private _location: Location,
              private http: HttpClient) {

    this.getRoamnigPartners();

    this.roamingPartnersModel = new RoamingPartnersModel();
  }

  verifyRoamingPolicy() {
    if (this.roamingPartnersModel.roamingPolicy == "Unrestricted Peering") {
      this.roamingPolicyType = "UP";
      this.roamingPartnersModel.outgoingDL = '0';
      this.roamingPartnersModel.outgoingUL = '0';
      this.roamingPartnersModel.incomingDL = '0';
      this.roamingPartnersModel.incomingUL = '0';
    } else {
      this.roamingPolicyType = "BP";
    }
  }

  getRoamnigPartners() {
    var url = ApiEndpoints.GET_EDIT_ROAMING_AGREEMENT;
    var body = {
      "nsAid": this.route.snapshot.queryParams["netAid"],
      "nsBid": this.route.snapshot.queryParams["netBid"]
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.roamingPartnersModel.partnersRole.fNS = data.allowPR_fromAtoB;
          this.roamingPartnersModel.partnersRole.sNS = data.allowPR_fromBtoA;
          this.roamingPartnersModel.ownDevices = data.allowPRA_fromAtoB;
          this.roamingPartnersModel.partnerDevice = data.allowPRA_fromBtoA;
          this.roamingPartnersModel.roamingPolicy = data.roamingPolicyType;
          this.roamingPartnersModel.incomingUL = data.ulThreshold_fromBtoA;
          this.roamingPartnersModel.outgoingUL = data.ulThreshold_fromAtoB;
          this.roamingPartnersModel.incomingDL = data.dlThreshold_fromBtoA;
          this.roamingPartnersModel.outgoingDL = data.dlThreshold_fromAtoB;
        }
      );
  }

  updateModelOnOwnPRAChanged() {
    if(this.roamingPartnersModel.ownDevices == true) {
      this.roamingPartnersModel.partnersRole.fNS = true;
    }
  }
  updateModelOnPartnerPRAChanged() {
    if(this.roamingPartnersModel.partnerDevice == true) {
      this.roamingPartnersModel.partnersRole.sNS = true;
    }
  }
  updateModelOnFnsChanged() {
    if(this.roamingPartnersModel.partnersRole.fNS == false) {
      this.roamingPartnersModel.ownDevices = false;
    }
  }
  updateModelOnSnsChanged() {
    if(this.roamingPartnersModel.partnersRole.sNS == false) {
      this.roamingPartnersModel.partnerDevice = false;
    }
  }

  save() {
    this.verifyRoamingPolicy();

    var body: any = {
      "nsAid": this.nsAid,
      "nsBid": this.nsBid,
      "roamingPolicyType": this.roamingPolicyType,
      "allowPRA_fromAtoB": this.roamingPartnersModel.ownDevices,
      "allowPRA_fromBtoA": this.roamingPartnersModel.partnerDevice,
      "allowPR_fromAtoB": this.roamingPartnersModel.partnersRole.fNS,
      "allowPR_fromBtoA": this.roamingPartnersModel.partnersRole.sNS,
      "ulThreshold_fromAtoB": Number(this.roamingPartnersModel.outgoingUL),
      "ulThreshold_fromBtoA": Number(this.roamingPartnersModel.incomingUL),
      "dlThreshold_fromAtoB": Number(this.roamingPartnersModel.outgoingDL),
      "dlThreshold_fromBtoA": Number(this.roamingPartnersModel.incomingDL)
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = ApiEndpoints.SET_EDIT_ROAMING_AGREEMENT;
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this._location.back();
        }
      );
  }

  backClicked() {
    this._location.back();
  }

  ngOnInit() {
    this.nsAid = this.route.snapshot.queryParams["netAid"];
    this.nsBid = this.route.snapshot.queryParams["netBid"];
    this.name = this.route.snapshot.queryParams["name"];
    this.partnerName = this.route.snapshot.queryParams["partnerName"];
    this.netIds = this.route.snapshot.queryParams["id"].toString();
    this.partnerNetIds = this.route.snapshot.queryParams["partnerId"];
  }

}
